import React, { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';

export const CookieWidget = () => {
  const [showWidget, setShowWidget] = useState(false);

  useEffect(() => {
    // Check if user has given consent
    const checkConsent = () => {
      const consent = localStorage.getItem('cookieConsent');
      setShowWidget(!!consent);
    };

    // Initial check
    checkConsent();

    // Listen for consent changes
    window.addEventListener('cookieConsentChanged', checkConsent);

    return () => {
      window.removeEventListener('cookieConsentChanged', checkConsent);
    };
    // Empty deps: checkConsent defined inside effect, setShowWidget is stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenSettings = () => {
    // Remove consent from localStorage
    localStorage.removeItem('cookieConsent');
    
    // Reload page to trigger CookieBanner
    window.location.reload();
  };

  if (!showWidget) return null;

  return (
    <>
      {/* Floating Cookie Widget Button */}
      <button
        onClick={handleOpenSettings}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-cyan-600 hover:bg-cyan-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
        aria-label="Gestisci impostazioni cookie"
        title="Gestisci Cookie"
      >
        <Cookie className="w-6 h-6 group-hover:scale-110 transition-transform" />
        
        {/* Tooltip */}
        <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Gestisci Cookie
        </span>
      </button>
    </>
  );
};
